import axios from 'axios';

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000
});

request.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

request.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response && error.response.status === 401 && !location.hash.includes('/login')) {
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_username');
      location.hash = '#/login';
    }
    return Promise.reject(error);
  }
);

export default request;
